import React, { useState } from 'react'
import { API_URL } from '../config';

const Contact = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        message: ''
    });
    const [status, setStatus] = useState({
        success: false,
        error: ''
    });
    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        email: '',
        message: ''
    });

    const validateName = (name) => {
        const nameRegex = /^[A-Za-z\s]{2,50}$/;
        return nameRegex.test(name.trim());
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        return emailRegex.test(email.trim());
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [id]: value
        }));
        // Clear error when user types
        if (errors[id]) {
            setErrors(prev => ({
                ...prev,
                [id]: ''
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation
        let formIsValid = true;
        const newErrors = { firstName: '', lastName: '', email: '' };

        if (!validateName(formData.firstName)) {
            newErrors.firstName = 'Please enter valid first name.';
            formIsValid = false;
        }
        if (!validateName(formData.lastName)) {
            newErrors.lastName = 'Please enter valid last name.';
            formIsValid = false;
        }
        if (!validateEmail(formData.email)) {
            newErrors.email = 'Please enter valid Email.';
            formIsValid = false;
        }
        if (!formData.message.trim()) {
            newErrors.message = 'Message is required.';
            formIsValid = false;
        }

        if (!formIsValid) {
            setErrors(newErrors);
            return;
        }

        setStatus({ success: true, error: '' });

        try {
            const response = await fetch(API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                // Try to parse error message if available, else generic
                throw new Error('Something went wrong. Please try again.');
            }
            //if  wait for response
            // setStatus({ success: true, error: '' });
            setFormData({ firstName: '', lastName: '', email: '', message: '' });

        } catch (err) {
            setStatus({ success: false, error: err.message });
        }
    };

    return (
        <main className="contact">
            <section className="section-01">
                <div className="wrapper">
                    <div className="content">
                        <h1 className="heading">Contact Us</h1>
                        <p className="text">We’re glad you’re here.<br />You can drop us a note through the form below, or email
                            at <a href="mailto:feelingalive@ikigai365.com">feelingalive@ikigai365.com</a> and we’ll get back
                            to you as soon as we can.
                        </p>
                        <p className="text">“And if you face a tiny glitch, try again gently — just like life, it all works
                            better at your own pace.”</p>
                        <div className="leadform">
                            <form className="form" onSubmit={handleSubmit} noValidate>
                                <div className="form-group">
                                    <label htmlFor="firstName">First Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        aria-describedby="emailHelp"
                                        placeholder="First name"
                                    />
                                    {errors.firstName && <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.firstName}</p>}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="lastName">Last Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        aria-describedby="emailHelp"
                                        placeholder="Last name"
                                    />
                                    {errors.lastName && <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.lastName}</p>}
                                </div>
                                <div className="form-group email">
                                    <label htmlFor="email">Email</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        aria-describedby="emailHelp"
                                        placeholder="your@company.com"
                                    />
                                    {errors.email && <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.email}</p>}
                                </div>
                                <div className="form-group message">
                                    <label htmlFor="message">Message</label>
                                    <textarea
                                        className="form-control"
                                        id="message"
                                        rows="3"
                                        value={formData.message}
                                        onChange={handleChange}
                                        placeholder='Enter your message'
                                    ></textarea>
                                    {errors.message && <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{errors.message}</p>}
                                </div>

                                <button type="submit" className="btn btn-primary">
                                    Send message
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            {status.success && (
                <section className="thankyou">
                    <div className="wrapper">
                        <button className="btn close" onClick={() => setStatus({ ...status, success: false })}>
                            <span className="material-icons-outlined">close</span>
                        </button>
                        <div className="modal-body">
                            <img src={require("../assets/images/check.png")} width="60" alt="check" />
                            <h5 className="heading">Thank You for Reaching Out</h5>
                            <p className="text">Your message has been received, and we truly appreciate you taking the time to write to us. Our team will review your note and get back to you as soon as possible.</p>
                        </div>
                    </div>
                </section>
            )}
        </main>

    )
}

export default Contact
